import PlaningToolRoot from '../PlaningToolRoot'
import { MItem } from '../Menu'
import { Box, Stack } from '@mui/material'
import NewsworthyModule from './NewsworthyModule'

export default function DashboardDemo() {
  return (
    <PlaningToolRoot
      standalone
      menuItem={MItem.dashboardDemo}
      mainContentClass="DashboardDemo flex flex-column"
    >
      <div className="contentHeader">
        <h2>Dashboard Demo</h2>
      </div>
      <Box sx={{ padding: 2 }}>
        <Stack spacing={3}>
          <NewsworthyModule />
        </Stack>
      </Box>
    </PlaningToolRoot>
  )
}
